import { render, staticRenderFns } from "./FileDownloadBtn.vue?vue&type=template&id=340f187f&scoped=true&"
import script from "./FileDownloadBtn.vue?vue&type=script&lang=js&"
export * from "./FileDownloadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f187f",
  null
  
)

export default component.exports